import storage from 'utils/storage';

import { LAST_ACTIVITY_KEY } from './constants';

export const resetLastActivityStorage = () => {
  storage.removeItem(LAST_ACTIVITY_KEY);
};
